import { defineComponent as _defineComponent } from 'vue'
import { defineProps } from "../../../../adapter-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'message-tip',
  props: {
  content: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props



return { __sfc: true,props }
}

})